import { 
  Action, 
  OperationType, 
  WindowManagerOperationNames 
} from '../../../dispatcher/Types';

export const addRecords: Action = [{
  moduleName: 'NavigationGrid',
  name: 'insertRecords',
  args: ['insertRecordsToMultiplePositions']
}];

export const ReconfigureColumns: Action = [{
  executeType: 'visible',
  args: ['columns'],
  moduleName: 'DashboardGrid',
  name: 'reconfigureColumns'
}];

export const addRowToGrid: Action = [{
  name: WindowManagerOperationNames.isActiveWindowWarning,
  type: OperationType.windowManager
}, {
  condition: '!{isActiveWindowWarning}',
  conditionOperations: [{
    evaluate: true,
    moduleName: '{moduleName}',
    moduleId: '{moduleId}',
    name: 'addRow',
    args: ['dataItem', 'editField']
  }],
  type: OperationType.conditional
}];

export const deleteRowActivity: Action = [{
  moduleName: 'NavigationBaseGrid',
  name: 'deleteRow',
  args: ['dataItem']
}];

export const scrollToRowAction: Action = [{
  name: 'scrollToRowIndex',
  moduleName: 'NavigationGrid',
  args: ['rowIndexToScroll']
}];

export const scrollToRowToDown: Action = [{
  data: {
    rowIndexToScroll: 49998
  },
  name: 'scrollToRowIndex',
  moduleName: 'NavigationGrid',
  args: ['rowIndexToScroll']
}];

export const scrollToRowWithImageCorrection: Action = [{
  persistent: ['rowIndexToScrollImg'],
  type: OperationType.addPersistentData
}, {
  name: 'scrollToRowIndexWithImageCorrection',
  moduleName: 'NavigationGrid',
  args: ['rowIndexToScrollImg']
}];

export const scrollToRowAfterLoadingCellSegment: Action = [{
  condition: '{rowIndexToScrollImg} || {rowIndexToScrollImg} == 0 || {rowIndexToScrollImg} === undefined',
  conditionOperations: [{
    name: 'setCorrectionAfterImagesLoad',
    moduleName: 'NavigationGrid',
    args: ['rowIndexToScrollImg']
  }],
  type: OperationType.conditional
}];

export const scrollToRowAfterCorrection: Action = [{
  persistent: ['rowIndexToScrollImg'],
  type: OperationType.removePersistentData
}];
